import { apiGet, apiPut } from '../../../components/qv4/models/shared/apiClient';

export const imageIdentity = image => { const value = typeof image === 'string' ? image : image?.id ?? image?.path ?? image?.url ?? image?.filePath ?? image?.file_name ?? image?.fileName ?? null; return value == null ? null : String(value); };
const unwrap = response => response.data.data;
export const getPhotoTags = query => apiGet(`/query-photos-v1/queries/${query}/tags`).then(unwrap);
export const putPhotoTags = (query, version, tags) => apiPut(`/query-photos-v1/queries/${query}/tags`, { expected_version: version, tags }).then(unwrap);
export const photoPartIdentity = part => part.id != null || part.query_part_id != null ? Number(part.id ?? part.query_part_id) : part.client_key;
export function photoLabel(photo, parts = []) {
  if (photo?.part_removed) return 'Part removed: choose again';
  if (!photo || photo.general) return 'General';
  if (photo.query_part_ids.length > 1) return `${photo.query_part_ids.length} parts`;
  return parts.find(part => photoPartIdentity(part) === photo.query_part_ids[0])?.part_name || 'Part';
}
export function photoFullLabel(photo, parts = []) {
  if (!photo || photo.general || photo.part_removed) return photoLabel(photo, parts);
  return photo.query_part_ids.map(id => parts.find(part => photoPartIdentity(part) === id)?.part_name || 'Part').join(', ');
}
export function partPhotoSummary(data, partId) {
  if (!data) return null;
  const photos = (data.photos || []).filter(photo => !photo.part_removed && photo.query_part_ids?.includes(partId));
  const generalCount = (data.photos || []).filter(photo => photo.general && !photo.part_removed).length;
  return photos.length || generalCount ? { photos, generalCount } : null;
}
export function recipientPhotos(photos, chosen, parts, team = false) {
  return (photos || []).filter(photo => photo.image_id && chosen.includes(photo.image_id) && !photo.part_removed
    && (team || photo.general || photo.query_part_ids.some(id => parts.includes(id)))).map(photo => photo.image_id);
}
